"use client";

import {
	FilterChips,
	FilterPanel,
	selectAppliedFilters,
	type FilterPanelPresentation
} from "@/composites/product-listing";

import { useListingState } from "../../listing-state";

export interface ListingFiltersProps {
	presentation: FilterPanelPresentation;
}

export function ListingFilters({
	presentation
}: ListingFiltersProps): JSX.Element | null {
	const { groups, toggle, setRange, total, clearAll } = useListingState();
	const isDrawer = presentation === "drawer";
	const applied = selectAppliedFilters(groups);

	return (
		<FilterPanel
			groups={groups}
			presentation={presentation}
			onValueChange={(change) => toggle(change.groupId, change.value)}
			onRangeChange={({ groupId, ...range }) => setRange(groupId, range)}
			{...(isDrawer && {
				labels: {
					trigger:
						applied.length > 0
							? `Filters (${applied.length})`
							: "Filters"
				},
				resultCount: total,
				onClearAll: clearAll,
				drawerSummary: (
					<FilterChips
						applied={applied}
						onRemove={(filter) =>
							toggle(filter.groupId, filter.value)
						}
					/>
				)
			})}
		/>
	);
}

/** Left rail of facet groups on a subcategory page. */
export function FilterRail(): JSX.Element | null {
	return <ListingFilters presentation="inline" />;
}
